<template>
  <div v-if="!complete">
    <div v-if="!user.id" class="top">
      <div class="top-nickname">
        <input
        
        placeholder="请输入本人昵称，谨防诈骗❗️"
                  class="top-nickname-input"
          v-model="username"
          id="input-name"
        />
        <p class="top-nickname-tips">{{ tips }}</p>
      </div>
      <button class="top-button" @click="usernameClick(false)">确认</button>
    </div>
    <div v-else >
      <div class="top">
        <div class="user">
        <img :src="user.avatar + 'thumb'" class="user-avatar" />
        <div class="user-detail">
          <p class="user-nickname">{{ user.nickname }}</p>
          <span class="user-level" v-if="user.wealth > 0">
            <span class="user-level-icon"></span>
            {{ user.wealth }}
          </span>
        </div>
        <button class="user-switch" @click="clearUser">切换</button>
      </div>
      </div>
      <div style="text-align: left;padding-left: 20px;background: #fff;padding: 10px 16px;color: #666;">请确认是否为本人的昵称头像</div>
    </div>
    <div class="vip-list-bg">
      <p class="vip-list-title">请选择会员类型</p>
      <div class="vip-list">
        <label v-for="(item, index) in charge" :key="item.id">
          <div
            class="vip-container"
            v-on:click="select = index"
            :class="select == index ? 'vip-container-selected' : ''"
          >
            <div class="vip-pri-price">
              {{ item.original_price == 0 ? "" : item.original_price / 100 }}
            </div>
            <div
              class="vip-price"
              :class="select == index ? 'vip-price-selected' : ''"
            >
              ¥{{ item.price / 100 }}
            </div>
            <div class="vip-name">{{ item.name }}</div>
          </div>
        </label>
      </div>
    </div>
    <div class="vip-pay-price">
      金额:
      <span style="color: #f109f3; font-size: 14px">{{ rmb || 0 }}元</span>
    </div>
    <div class="vip-pay-method">
      <p class="vip-pay-title">请选择支付方式</p>

      <div class="vip-pay-item" @click="client = 'wechat'">
        <div style="display: flex; align-items: center">
          <img src="../assets/vip_wachat.png" width="22px" height="22px" />
          <span style="padding-left: 5px">微信支付</span>
        </div>
        <img
          v-if="client == 'wechat'"
          src="../assets/recharge_check_s.png"
          width="16px"
          height="16px"
        />
        <img
          v-else
          src="../assets/recharge_check_n.png"
          width="16px"
          height="16px"
        />
      </div>


      <div class="vip-pay-item" @click="client = 'alipay'">
        <div style="display: flex; align-items: center">
          <img src="../assets/vip_zhifubao.png" width="22px" height="22px" />
          <span style="padding-left: 5px">支付宝支付</span>
        </div>

        <img
          v-if="client == 'alipay'"
          src="../assets/recharge_check_s.png"
          width="16px"
          height="16px"
        />
        <img
          v-else
          src="../assets/recharge_check_n.png"
          width="16px"
          height="16px"
        />
      </div>
    </div>

    <p style="color: #bababa; font-size: 12px;height:20px;">
     
    </p>

    <div style="color: #999999; text-align: left; margin-left: 10px; margin-top:10px;">
       <p> 请注意：充值成功后，无法退款</p>
     <p>微信支付若提示“商家参数格式有误”，请刷新当面页面或开启无痕浏览即可解决</p>
    </div>

    <button class="bottom" :disabled="!rmb > 0 || !user.id" @click="payClick">
      立即开通
    </button>

    <div class="alipay-copy" v-if="alipay_url">
      <p>请复制以下文本到浏览器中打开</p>
      <p style="width: 100%; font-size: 10px; word-wrap: break-word">
        {{ alipay_url }}
      </p>
    </div>
    <div class="toast" v-if="show_toast">{{ toast_text }}</div>
  </div>
  <div v-else>
    <div class="complete">
      <img class="complete-icon" src="../assets/recharge_complete.png" />
      <p style="color: #181818; font-size: 20px; font-weight: 500; margin: 0">
        开通成功
      </p>
    </div>
    <div class="complete-container">
      <p class="complete-text">
        <span style="color: #999999">用户名</span>
        <span style="color: #181818">{{ user.nickname }}</span>
      </p>
      <p class="complete-text">
        <span style="color: #999999">会员类型</span>
        <span style="color: #181818">{{ gold }}</span>
      </p>
    </div>
    <!-- <button class="button-exit" @click="window.opener=null;window.close()">退出</button> -->
    <button class="button-continue" @click="complete = !complete">
      继续开通
    </button>
  </div>
</template>

<script>
import request from "../request.js";
// let host = "http://sm-debug.taowoapp.com";
// let host = "https://sm.appwuhui.com";
export default {
  name: "Vip",
  data() {
    return {
      select: 0,
      other: "",
      tips: "",
      complete: false, // 一会要改回来
      charge: [],
      username: "",
      user: {
        id: 0,
        nickname: "",
        avatar: "",
        wealth: 0,
      },
      client: "wechat",
      alipay_url: "",
      isWeixin:
        navigator.userAgent.toLowerCase().indexOf("micromessenger") != -1,
        show_toast: false,
      toast_text: "",
    };
  },
  created() {
    var name = this.getUrlParam("name");
    var pid = this.getUrlParam("pid");
    this.sm_sign = this.getUrlParam("s") || "null";

    if (pid) {
      this.pid = pid;
    }
    // 接收从客户端传来的name
    if (name) {
      this.username = decodeURIComponent(name);
      this.usernameClick(true);
    }
    if (this.isWeixin && !window.location.search.match(/open_id=/i)) {
      this.axios
        .get(`https://api.taowoapp.com/api/wechat/login/?url=${window.location.href}`)
        .then((response) => {
          window.location.href = response.data.data.url;
        });
    }
  },
  mounted() {
    if (!this.isWeixin) {
      this.client = "alipay";
    }
    request.get(`/api/payment/web_vip_products/`).then((response) => {
      console.log(response)
      let data = response.data;
      this.charge = data.list;
      for (var i = 0 ; i < this.charge.length; i++) {
          var p = this.charge[i]
          if (p.id == this.pid) {
            this.select = i
            break
          }
      }
    });
  },
  computed: {
    gold() {
      if (this.select == -1) {
        return "";
      } else {
        return this.charge[this.select] && this.charge[this.select].name;
      }
    },
    rmb() {
      if (this.select == -1) {
        return this.other;
      } else {
        return this.charge[this.select] && this.charge[this.select].price / 100;
      }
    },
  },
  methods: {
    showTip(tip) {
      if (tip && tip.length > 0) {
        this.toast_text = tip;
        this.show_toast = true;
        setTimeout(() => {
          this.show_toast = false;
        }, 3000);
      }
    },
    payClick() {
      let select = this.charge[this.select];
      let client = "h5";
      if (this.isWeixin) {
        client = this.client == "wechat" ? "js" : "h5";
      }
      var returnUrl = window.location.origin + window.location.pathname;
      var name = this.username;
      if (name) {
        returnUrl = returnUrl + "?name=" + encodeURIComponent(name)
      }
      request
        .post(`/api/payment/web_pay/`, {
          user_id: this.user.id,
          price: select.price,
          product_id: select.id,
          platform: client,
          return_url: returnUrl,
          quit_url: "",
          client: this.client,
          open_id: this.getUrlParam("open_id") || ""
        })
        .then((response) => {
          let data = response.data;
          // eslint-disable-next-line no-console
          // console.log(data)
          if (this.client == "wechat" && this.isWeixin) {
            this.onBridgeReady(data.url);
          } else {
            // eslint-disable-next-line no-console
            if (this.isWeixin) {
              this.alipay_url = data.url;
            } else {
              window.location.href = data.url;
            }
          }
        })
        .catch((e) => {
          alert(e);
        });
    },
    usernameClick(isAuto) {
      var params = {
        nickname: this.username,
      }
      if (isAuto) {
        params.s = this.sm_sign
      }
     request
        .post(`/api/payment/verify_web_user/`, params)
        .then((response) => {
          let data = response.data;
          Object.assign(this.user, data);
          for (var item of data.badges) {
            if (item.startsWith("wealth_")) {
              this.user.wealth = item.match(/wealth_(\d+)/i)[1];
            }
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          if (err.response.status == 404) {
            if (!isAuto) {
              this.showTip("该用户不存在");
            } else {
              this.username = ""
            }
          } else if (err.response.data.message) {
            this.showTip(err.response.data.message);
          } else {
            alert(err);
          }
        });
    },
    clearUser() {
      this.user = {
        id: 0,
        nickname: "",
        avatar: "",
        wealth: 0,
      };
      this.username = "";
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    onBridgeReady(data) {
      if (typeof WeixinJSBridge == "undefined") {
        return;
      }
      // eslint-disable-next-line no-console
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: data.appId, //公众号名称，由商户传入
          timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: data.nonceStr, //随机串
          package: data.package,
          signType: data.signType, //微信签名方式：
          paySign: data.paySign, //微信签名
        },
        (res) => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            this.complete = true;
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
            // eslint-disable-next-line no-console
            console.log("用户取消");
          } else if (res.err_msg == "get_brand_wcpay_request:fail") {
            // eslint-disable-next-line no-console
            console.log("支付失败");
          } else {
            alert("充值失败请稍后重试");
            // eslint-disable-next-line no-console
            console.log("反正失败了" + res.err_msg);
          }
        }
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.top {
  height: 72px;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  &-nickname {
    position: relative;
    width: 100%;

    &-input {
      font-size: 14px;
      color: rgba(24, 24, 24, 1);
      line-height: 14px;
      outline: none;
      border: none;
    }
    &-tips {
      position: absolute;
      left: 3px;
      font-size: 12px;
      color: rgba(240, 48, 78, 1);
      line-height: 12px;
      margin: 0;
    }
  }
  &-button {
    background: #f109f3;
    outline: none;
    height: 32px;
    width: 66px;
    font-size: 14px;
    color: #ffffff;
    margin: 0;
    padding: 0;
    border-radius: 1px;
    border: 0;
  }
  .user {
    display: flex;
    align-items: center;
    width: 100%;
    &-avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      display: inline-block;
    }
    &-detail {
      margin-left: 10px;
      text-align: left;
    }
    &-nickname {
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
      margin: 0;
    }
    &-level {
      text-align: left;
      font-size: 9px;
      line-height: 9px;
      margin: 0;
      padding: 2px;
      background: linear-gradient(
        90deg,
        rgba(255, 170, 43, 1) 0%,
        rgba(253, 189, 32, 1) 100%
      );
      border-radius: 2px;
      display: inline-block;
      color: #f7f7ff;
      &-icon {
        background: url("../assets/data_recharge_diamond.png");
        width: 11px;
        height: 10px;
        background-size: 100%;
        display: inline-block;
        vertical-align: middle;
      }
    }
    &-switch {
      display: inline-block;
      padding: 9px 18px;
      border-radius: 1px;
      border: 1px solid rgba(237, 237, 237, 1);
      background: white;
      margin-left: auto;
    }
  }
}

.bottom {
  position: fixed;
  bottom: 0;
  height: 44px;
  width: 100%;
  left: 0;
  color: #ffffff;
  background: #f109f3;
  font-weight: 500;
  font-size: 14px;
  margin: 0;
  padding: 0;
  border: 0;
  outline: none;
  &[disabled] {
    background: #d5d5d5;
  }
}

.complete {
  background: white;
  height: 148px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;
  &-icon {
    width: 68px;
    height: 68px;
    display: block;
    margin-bottom: 20px;
  }
  &-container {
    padding: 10px 0;
    background: white;
  }
  &-text {
    margin: 0;
    padding: 10px 15px 10px 20px;
    display: flex;
    justify-content: space-between;
  }
}
.button {
  &-exit {
    width: 265px;
    height: 48px;
    background: #f4f4f4;
    border-radius: 1px;
    border: 1px solid rgba(241, 9, 243, 1);
    color: #f109f3;
    margin-bottom: 12px;
    margin-top: 60px;
  }
  &-continue {
    margin-bottom: 12px;
    margin-top: 60px;
    width: 265px;
    height: 48px;
    background: rgba(241, 9, 243, 1);
    border-radius: 1px;
    color: #f7f7ff;
    font-size: 16px;
    padding: 0;
    border: 0;
    outline: none;
  }
}
// input[type='radio'] {
//    -webkit-appearance: none;
// }
.alipay-copy {
  padding: 40px;
  position: fixed;
  display: flex;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: white;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: black;
}

.vip-list-bg {
  margin-top: 10px;

  background-color: #ffffff;
  padding: 10px 0px 20px 0px;
}

.vip-list-title {
  color: #5e5e68;
  font-size: 14px;
  padding-bottom: 5px;
}

.vip-list {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.vip-container {
  border-radius: 4px;
  border: 2px solid rgba(244, 244, 244, 1);
  width: 106px;
  height: 106px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.vip-pri-price {
  color: #b3971f;
  font-size: 14px;
  text-decoration: line-through;
}

.vip-price {
  font-size: 28px;
}

.vip-name {
  font-size: 12px;
  color: #5e5e68;
}

.vip-price-selected {
  color: #f109f3;
}

.vip-container-selected {
  border: 2px solid rgba(241, 9, 243, 1);
}

.vip-pay-price {
  height: 44px;
  line-height: 44px;
  padding-left: 22px;
  background-color: #ffffff;
  text-align: left;
  margin-top: 10px;
  font-size: 16px;
}

.vip-pay-method {
  background-color: #ffffff;
  margin-top: 10px;
  padding-top: 10px;
}
.vip-pay-title {
  color: #5e5e68;
  font-size: 14px;
}
.vip-pay-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 15px 20px 15px;
  font-size: 14px;
}
#input-name {
  width: 100%;
  box-sizing: border-box;
}
.toast {
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
  z-index: 99;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 8px 8px 8px 8px;
  padding: 10px 15px;
  color: white;
}
</style>
